export default __webpack_public_path__ + "static/media/deloitte-logo.afaa1744.svg";